import { BlogSingleDataType } from "../../../Types/Blog/BlogType";

export const blogData = [
    { image: "2", hits: "0", date: "02" },
    { image: "3", hits: "02", date: "03" },
  ];
  
  export const blogDataList = ["blog-5.jpg", "blog-6.jpg", "blog-5.jpg", "blog-6.jpg"];
  
  export const radioData = [
    {
      text: "Text",
    },
    {
      text: "Image",
    },
    {
      text: "Audio",
      defaultChecked: true,
    },
    {
      text: "Video",
    },
  ];
  
  export const postTypeData = [{ name: "Lifestyle" }, { name: "Travel" }];



  export const blogSingleData:BlogSingleDataType[] = [
    {
        id: 1,
        src: 'blog/comment.jpg',
        name: 'Mark Jolio',
        post: 'Designer',
        hits: '02 Hits',
        comments: '598 Comments',
        detail: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`,
    },
    {
        id: 2,
        src: 'blog/9.jpg',
        name: 'Jolio Mark',
        post: 'Designer',
        hits: '02 Hits',
        comments: '598 Comments',
        detail: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`,
    },
    {
        id: 3,
        src: "blog/4.jpg",
        name: 'Harf Mark',
        post: 'Designer',
        hits: '02 Hits',
        comments: '598 Comments',
        detail: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`,
    },
    {
        id: 4,
        src: 'blog/12.png',
        name: 'Zohn Cena',
        post: 'Designer',
        hits: '02 Hits',
        comments: '598 Comments',
        detail: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`,
    },
    {
        id: 5,
        src: 'blog/14.png',
        name: 'Robart Draf',
        post: 'Designer',
        hits: '02 Hits',
        comments: '598 Comments',
        detail: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`,
    },
]